/*eslint-disable */

//import CloudinaryVideoPlayer from './CloudinaryVideoPlayer'
import * as cloudinary from "cloudinary-core";

import { tns } from "../../../node_modules/tiny-slider/src/tiny-slider";

import { create as createPipe } from "../sigpipe";

import { map } from "./map";
import { mapSimple } from "../../components/mapSimple";

import interactiveChapelleInternational from "../interactive-images/chapelle-international";

class App {
  constructor(selector) {
    this.ready = document.readyState === "interactive";

    if (!this.ready) {
      document.addEventListener("DOMContentLoaded", () => {
        this.element = document.querySelector(selector);

        if (typeof this.callback === "function") {
          this.callback();
        }
      });
    } else {
      this.element = document.querySelector(selector);
    }
  }

  onReady(callback) {
    this.callback = callback;
    this.init();

    if (this.ready) {
      callback();
    }
  }

  /*initVideoPlayer () {
    let videos = document.getElementsByClassName('cloudinary-video-player');
    Array.prototype.forEach.call(videos, function(el){
      let vp = new CloudinaryVideoPlayer(el)
    })
  }*/

  initResponsivePicture() {
    let cl = cloudinary.Cloudinary.new({
      cloud_name: config.cloudinary.options.cloud_name
    });
    cl.responsive();
  }

  /******** T O  C L E A N ********/

  // slider case studies (autoplay + no arrow + bullets)
  initCaseStudiesSlider() {
    let isMobile = window.innerWidth < 768; // TO REFACT !

    var slider = tns({
      container: ".js-slider-cs",
      mode: "gallery",
      autoplay: isMobile ? false : true,
      controls: false,
      speed: 1000,
      mouseDrag: isMobile ? true : false,
      arrowKeys: true,
      navContainer: ".js-bullets",
      autoplayButton: ".js-slider-autoplay",
      autoplayText: [
        '<svg class="play" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.999 41.999" height="15"><path d="M36.068 20.176l-29-20A1 1 0 1 0 5.5.999v40a1 1 0 0 0 1.568.823l29-20a.999.999 0 0 0 0-1.646z" fill="#FFF"/></svg>',
        '<svg class="pause" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 847 1058.75" height="15" width="15"><path d="M111 35h246v777H111V35zm379 0h246v777H490V35z" fill="#FFF"/></svg>'
      ]
    });
  }

  // slider img header
  initHeaderSlider() {
    let isMobile = window.innerWidth < 768;

    var slider = tns({
      container: ".js-slider-img-header",
      autoplay: true,
      mode: "gallery",
      controls: false,
      speed: 1000,
      mouseDrag: isMobile ? true : false,
      arrowKeys: true,
      navContainer: ".js-bullets"
    });
  }

  // slider actors: 3 items + arrows
  initSliderActors() {
    document.querySelectorAll(".js-slider-actors").forEach(function(el) {
      var slider = tns({
        container: el,
        nav: false,
        speed: 1000,
        prevButton: el.parentNode.parentNode.querySelector(
          ".js-prev-btn-actor"
        ),
        nextButton: el.parentNode.parentNode.querySelector(
          ".js-next-btn-actor"
        ),
        arrowKeys: true,
        items: 1,
        autoHeight: false,
        gutter: 20,
        responsive: {
          640: {
            items: 2
          },
          1024: {
            items: 3
          }
        }
      });
    });
  }

  // slider calendar: bullets only, fade
  initCal() {
    Array.prototype.forEach.call(
      document.querySelectorAll(".slice_calendar"),
      function(el) {
        var slider = tns({
          container: el.querySelector(".js-slider-cal"),
          mode: "gallery",
          controls: false,
          speed: 1000,
          navContainer: el.querySelector(".js-bullets-cal"),
          arrowKeys: true,
          autoHeight: true
        });
      }
    );
  }

  // slider img: arrows only
  initSlider() {
    var slider = tns({
      container: ".js-slider-img",
      mode: "gallery",
      nav: false,
      speed: 1000,
      prevButton: ".js-prev-btn",
      nextButton: ".js-next-btn",
      arrowKeys: true
    });
  }

  initPublis() {
    var btn = document.getElementsByClassName("js-more-publis")[0];

    btn.addEventListener("click", () => {
      var publis = document.querySelectorAll(".js-publi.hidden");

      [].forEach.call(publis, (publi, i) => {
        if (i < 8) {
          publi.classList.remove("hidden");
          publi.classList.add("flex");
        } else {
          return;
        }
      });

      if (publis.length <= 8) {
        btn.classList.add("hidden");
        btn.classList.remove("flex");
      }
    });
  }

  initStudiesFilter(append, page) {
    const self = this;

    let data = new FormData();
    data.append(
      "region",
      document.querySelector(".js-studies-filter[name=regions] option:checked")
        .value
    );
    data.append(
      "project",
      document.querySelector(".js-studies-filter[name=projects] option:checked")
        .value
    );
    data.append(
      "type",
      document.querySelector(".js-studies-filter[name=type]:checked").value
    );
    data.append("page", page);

    const request = new XMLHttpRequest();
    request.open("POST", "/case-studies", true);

    request.onload = function() {
      if (request.status >= 200 && request.status < 400) {
        if (append) {
          document.querySelector("#case-studies-results").innerHTML +=
            request.responseText;
        } else {
          document.querySelector("#case-studies-results").innerHTML =
            request.responseText;
        }

        // show more
        if (document.querySelector(".show-more")) {
          document.querySelector(".show-more").addEventListener("click", () => {
            const button = document.querySelector(".show-more");
            const page = button.getAttribute("data-page");
            button.parentNode.removeChild(button);

            self.initStudiesFilter(true, page);
          });
        }
      }
    };

    request.send(data);
  }

  initArticlesFilter(append, page) {
    const self = this;

    const resultsWrapper = document.querySelector("#articles-results");

    let data = new FormData();
    data.append(
      "type",
      document.querySelector(".js-articles-filter[name=type] option:checked")
        .value
    );
    data.append("page", page);

    const request = new XMLHttpRequest();
    request.open("POST", "/articles", true);

    request.onload = function() {
      if (request.status >= 200 && request.status < 400) {
        if (append) {
          resultsWrapper.innerHTML += request.responseText;
        } else {
          resultsWrapper.innerHTML = request.responseText;
        }

        // show more
        if (document.querySelector(".show-more")) {
          document.querySelector(".show-more").addEventListener("click", () => {
            const button = document.querySelector(".show-more");
            const page = button.getAttribute("data-page");
            button.parentNode.removeChild(button);

            self.initArticlesFilter(true, page);
          });
        }
        self.articlesPipe.write({ action: "grid-populated" });
        //self.initGrid()
      }
    };

    request.send(data);
  }

  init() {
    //this.initVideoPlayer()
    this.initResponsivePicture();

    /*if(document.getElementsByClassName('cloudinary-video-player')[0]) {
      this.initVideoPlayer()
    }*/

    if (document.getElementsByClassName("js-slider-cs")[0]) {
      this.initCaseStudiesSlider();
    }

    if (document.getElementsByClassName("js-slider-cal")[0]) {
      this.initCal();
    }

    if (document.getElementsByClassName("js-slider-actors")[0]) {
      this.initSliderActors();
    }

    if (document.getElementsByClassName("js-slider-img")[0]) {
      this.initSlider();
    }

    if (document.getElementsByClassName("js-slider-img-header")[0]) {
      this.initHeaderSlider();
    }

    if (document.getElementsByClassName("js-more-publis")[0]) {
      this.initPublis();
    }

    if (document.getElementsByClassName("js-studies-filter")[0]) {
      this.initStudiesFilter(false, 1);
      const inputs = document.querySelectorAll(".js-studies-filter");

      inputs.forEach(input => {
        input.addEventListener("change", () => {
          this.initStudiesFilter(false, 1);
        });
      });
    }

    if (document.getElementsByClassName("js-articles-filter")[0]) {
      const resultsWrapper = document.querySelector("#articles-results");
      this.articlesPipe = createPipe();
      resultsWrapper.setAttribute("data-grid-pipe-id", this.articlesPipe.id);

      this.initArticlesFilter(false, 1);
      const inputs = document.querySelectorAll(".js-articles-filter");

      inputs.forEach(input => {
        input.addEventListener("change", () => {
          this.initArticlesFilter(false, 1);
        });
      });
    }

    // IMAGES INTERACTIVES
    if (document.querySelector(".interactive-image")) {
      if (
        document.querySelector(".interactive-image .chapelle-international")
      ) {
        interactiveChapelleInternational();
      }
    }
  }
}

export default App;
